// extracted by mini-css-extract-plugin
export default {"container":"DiscoverNFTs_container__Aub7S","cards":"DiscoverNFTs_cards__NKMnv"};